import React from "react";
import { useForm } from "react-hook-form";
import { RouteComponentProps } from "react-router";

import { Card, CardBody } from '../components/wombat-ui/components/Card';
import Button from '../components/wombat-ui/components/Button';
import Input from '../components/wombat-ui/components/Form/Input';

import Logo from "../components/Logo";
import useTranslations from "../hooks/useTranslations";
import useAddNotification from "../hooks/useAddNotification";

import useSendConnectionLink from "../graphql/hooks/mutations/useSendConnectionLink";

type ConnectionLinkFormData = {
  email: string;
};

type ConnectionLinkScreenProps = {} & RouteComponentProps<{}>;

const ConnectionLinkScreen: React.FC<ConnectionLinkScreenProps> = () => {
  const t = useTranslations();
  const [addNotification] = useAddNotification();
  const { register, handleSubmit, setValue } = useForm<ConnectionLinkFormData>();

  const [ sendConnectionLink ] = useSendConnectionLink();
  const onSubmit = handleSubmit(async ({ email }) => {
    try {
      await sendConnectionLink({
        variables: {
          input: { email }
        }
      });
      addNotification({
        variables: {
          title: t("connectionLink.sendSuccessTitle") as string,
          body: t("connectionLink.sendSuccessBody") as string,
          status: "success",
        },
      });
      setValue('email', '');
    } catch (error) {
      addNotification({
        variables: {
          title: t("forms.errors.notificationTitle") as string,
          body: t("forms.errors.emailOrPassword") as string,
          status: "error",
        },
      });
    }
  });

  return (
    <div className="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex flex-row justify-center">
          <Logo />
        </div>
        <h2 className="mt-6 text-2xl font-extrabold text-center text-dark-300">
          {t("connectionLink.connectionLink")}
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card>
          <CardBody>
            <form className="px-2 space-y-6" onSubmit={onSubmit} id="connectionLinkForm">
              <Input
                id="email"
                label={t("forms.fields.email")}
                name="email"
                type="email"
                autoComplete="email"
                required
                ref={register({ required: true })}
              />

              <Button type="submit" block>
                {t("forms.actions.send")}
              </Button>
            </form>

          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ConnectionLinkScreen;
